import {
  CURP_PATTERN,
  digitoVerificador,
  INE_PATTERN,
  RFC_PATTERN,
  EMAIL_PATTERN,
  digitoVerificadorRFC,
} from 'utils/patterns';

export const curpsGenericas = ['XEXX010101HNEXXXA4', 'XEXX010101MNEXXXA8'];
export const rfcGenerico = 'XEXX010101000';

export const formsRules = {
  requiredRule: {
    required: true,
    message: 'El campo es requerido',
  },
  required: {
    required: true,
    message: 'El campo es requerido',
  },
};

export const generateCURPRules = ({
  validateUnique = false,
  required = true,
  getter = () => Promise.resolve([]),
  label = 'registro',
  id,
  getFieldValue = () => ({}),
}) => [
  { required: Boolean(required) },
  {
    validator: async (rule, value) => {
      if (value) {
        if (getFieldValue('tipo_de_persona') === 3 && curpsGenericas.includes(value)) {
          return;
        }
        const validado = value.toUpperCase().match(CURP_PATTERN);
        if (!validado) {
          throw new Error('Ingrese una CURP válida.');
        }
        if (validado[2] !== digitoVerificador(validado[1])) {
          throw new Error('Dígito verificador incorrecto.');
        }
        if (validateUnique) {
          if (typeof getter !== 'function') {
            throw new Error('getter is not a function');
          }
          const propName = rule.field;
          const params = { [propName]: value };
          const matches = await getter(params);
          const match = (matches?.results || matches)
            .filter((e) => e.id !== id)
            .find((e) => e[propName] === value);
          if (match) {
            throw new Error(`Ya existe un ${label} con esta CURP.`);
          }
        }
      }
    },
  },
];

export const generateINERules = ({
  validateUnique = false,
  required = true,
  getter,
  label = 'registro',
  id,
  propName: _propName,
}) => [
  { required: Boolean(required) },
  {
    validator: async (rule, value) => {
      if (value) {
        const invalid = !INE_PATTERN.test(value);
        if (validateUnique && !invalid) {
          const propName = _propName || rule.field;
          const matches = await getter({ [propName]: value });
          const [match] = (matches.results || matches)
            .filter((e) => e.id !== id)
            .find((e) => e[propName] === value);
          if (match) {
            throw new Error(`Ya existe un ${label} con esta INE.`);
          }
        } else if (invalid) {
          throw new Error('Ingrese una INE válida.');
        }
      }
    },
  },
];

export const generateRFCRules = ({
  validateUnique = false,
  required = true,
  getter = null,
  label = 'registro',
  id: _id,
}) => ([
  ({ getFieldValue }) => ({
    validator: async (rule, _value) => {
      if (required && !_value) throw new Error(' ');

      if (_value) {
        if (_value === rfcGenerico) return;

        const rawValue = _value.toString();
        if (rawValue.length !== 12) {
          throw new Error('El RFC debe contener 12 caracteres');
        }
        const value = rawValue.trim().toUpperCase();

        if (!RFC_PATTERN.test(value)) {
          throw new Error('RFC inválido');
        }

        if (validateUnique && getter) {
          const id = _id || getFieldValue('id');
          const params = { RFC: value };
          const matches = await getter(params);
          const filteredMatches = matches?.results?.filter((e) => e.id !== id);
          const match = filteredMatches?.find((e) => e.RFC === value);

          if (match) {
            throw new Error(`Ya existe un ${label} con este RFC.`);
          }
        }
      }
    },
  }),
  () => ({
    validator: async (rule, _value) => {
      if (!_value || _value === rfcGenerico) return;

      const value = _value.toString().trim().toUpperCase();

      // Solo aplicamos verificación de dígito para RFCs de 13 caracteres (persona física)
      if (value.length === 13 && RFC_PATTERN.test(value)) {
        const _digitoVerificador = value.at(-1);
        const rfcSinDigito = value.substring(0, value.length - 1);
        const digitoVerificadorCalculado = digitoVerificadorRFC(rfcSinDigito);

        if (digitoVerificadorCalculado !== _digitoVerificador) {
          throw new Error(`Dígito verificador calculado es ${digitoVerificadorCalculado}. Si el valor introducido (${_digitoVerificador}) es correcto, puede continuar.`);
        }
      }
    },
    warningOnly: true,
  }),
]);

export const generateEmailRules = ({
  validateUnique = false,
  required = false,
  getter = null,
  label = 'registro',
  id,
  propName: _propName,
}) => [
  { required: Boolean(required) },
  {
    validator: async (rule, value) => {
      if (value) {
        const invalid = !EMAIL_PATTERN.test(value);
        if (validateUnique && !invalid) {
          const propName = _propName || rule.field;
          const matches = await getter({ [propName]: value });
          const [match] = (matches.results || matches)
            .filter((e) => e.id !== id)
            .find((e) => e[propName] === value);
          if (match) {
            throw new Error(`Ya existe un ${label} con esta RFC.`);
          }
        } else if (invalid) {
          throw new Error('Ingrese un correo eletrónico válido.');
        }
      }
    },
  },
];

export const generatePhoneRules = ({
  validateUnique = false,
  required = false,
  getter = null,
  label = 'registro',
  propName: _propName,
  id,
}) => [
  { required: Boolean(required) },
  {
    validator: async (rule, value) => {
      const invalid = !/^[0-9]{10}$/.test(value);
      if (validateUnique && !invalid) {
        const propName = _propName || rule.field;
        const params = { [propName]: value };
        const matches = await getter(params);
        const [match] = (matches.results || matches)
          .filter((e) => e.id !== id)
          .find((e) => e[propName] === value);
        if (match) {
          throw new Error(`Ya existe un ${label} con este número de celular.`);
        }
      }
    },
  },
];
